








































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Company, domain, DBBranchData, DBBranchBase, User, LogoShape, VueForm, OnlineVersion } from "@/domain";
import QuickSnack from "@/components/QuickSnack.vue";
import Upload from "@/components/Upload.vue";
import AvatarRef from "@/components/AvatarRef.vue";
import LinkRef from "@/components/LinkRef.vue";
import ColorPicker from "@/components/ColorPicker.vue";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import * as fileStorage from "@/domain/fileStorage";
import lodash from "lodash";
import { AnyErrorType } from "@/domain/error";

const DEFAULT_ONLINE_VERSION: OnlineVersion = "puce_v2";

@Component({
  components: { QuickSnack, AvatarRef, LinkRef, Upload, ColorPicker }
})
export default class BranchConfig extends Vue {
  branches: BranchItem[] = [];
  branchSearch = "";

  puceExpanded = false;
  paylinkExpanded = false;
  activeBranch: BranchItem | null = this.emptyBranchItem();
  activeSaving = false;

  lastRemoteError: string | null = null;
  loadingBranches = false;
  previewLoading = false;
  previewURLs = {
    logoURL: "",
    puceLogoURL: "",
    puceCustomCssURL: ""
  };

  urlKoInfo = "";
  get lang() {
    return this.$store.state.lang.data;
  }

  get branchGroups() {
    return [
      {
        name: this.lang.configuredOffices,
        branches: util.searchTermFilter(this.branchesConfigured, this.branchSearch, (i) => [i.title, i.subtitle])
      },
      {
        name: this.lang.available,
        branches: util.searchTermFilter(this.branchesNotConfigured, this.branchSearch, (i) => [i.title, i.subtitle])
      }
    ].filter((g) => g.branches.length > 0);
  }

  get branchesConfigured() {
    return this.branches.filter((b) => this.isConfigured(b.branch));
  }
  get branchesNotConfigured() {
    return this.branches.filter((b) => !this.isConfigured(b.branch));
  }

  get snackbar(): QuickSnack {
    return this.$refs.snackbar as QuickSnack;
  }

  get isLoading(): boolean {
    return this.$store.state.selectedCompanyLoading || this.loadingBranches;
  }

  get hasActiveBranch(): boolean {
    return !!this.activeBranch && this.activeBranch.branch.branchID !== 0;
  }

  get currentCompany(): Company | null {
    return this.$store.state.selectedCompany;
  }

  @Watch("currentCompany")
  onCompanyChanged(newCompany?: Company, oldCompany?: Company) {
    if (!newCompany || (oldCompany && newCompany.id === oldCompany.id)) {
      return;
    }
    this.activeBranch = this.emptyBranchItem();
    util.promiseEnd(this.refresh());
  }

  get currentUser(): User | null {
    return this.$store.state.currentUser;
  }

  created() {
    util.promiseEnd(this.refresh());
  }

  get shapeOptions() {
    return [
      {
        value: "circle",
        text: this.lang.circle
      },
      {
        value: "square",
        text: this.lang.square
      },
      {
        value: "rounded_square",
        text: this.lang.squareRounded
      }
    ];
  }

  get processingEnvOptions() {
    return [
      {
        value: "prod",
        text: "Producción"
      },
      {
        value: "preprod",
        text: "Pre-producción"
      }
    ];
  }

  async refresh() {
    this.lastRemoteError = null;
    if (this.currentCompany) {
      try {
        this.loadingBranches = true;
        const result = await domain.backend.paymentGetBranches(this.currentCompany.id);
        this.assignBranches(
          result.map((branch) => {
            return this.mapBranch(this.emptyBranchItem(), branch);
          })
        );
      } catch (err) {
        util.logError("Error getting branches", err);
        this.lastRemoteError = uiUtil.toErrorMsg(err, "Ocurrió un error con el servicio remoto.");
      }
    } else {
      this.lastRemoteError = "Seleccione un comercio para configurar sus oficinas";
    }
    this.loadingBranches = false;
  }

  assignBranches(branches: BranchItem[]) {
    this.branchSearch = "";
    this.branches = lodash(branches)
      .sortBy((b) => b.title)
      .value();
  }

  isConfigured(branch: DBBranchData): boolean {
    return !branch.isNew;
  }

  avatarName(item: BranchItem) {
    return item.title.substring(0, 1);
  }

  avatarColor(item: BranchItem) {
    let color = "#AAAAAA";
    if (item.logoRef) {
      color = "#FFFFFF";
    } else if (item.branch.branding.primaryColor) {
      color = item.branch.branding.primaryColor;
    }
    return color;
  }

  mapBranch(item: BranchItem, branch: DBBranchData) {
    item.branch = branch;
    item.draft = branch.draft ? lodash.cloneDeep(branch.draft) : undefined;
    item.title = branch.displayName || branch.name;
    item.subtitle = branch.name;
    item.logoRef = branch.branding.logoFileRef;
    item.logoShape = branch.branding.logoShape;
    item.status = this.isConfigured(branch) ? "Habilitada" : "Falta configurar";
    return item;
  }

  cmdSelectBranch(branch: BranchItem) {
    this.activeBranch = branch;
    if (!this.activeBranch.draft) {
      this.activeBranch.draft = {
        enabled: true,
        displayName: branch.branch.displayName || branch.branch.name,
        senderName: branch.branch.senderName || "Equipo de " + (branch.branch.displayName || branch.branch.name),
        resultEmail: branch.branch.resultEmail,
        resultURL: branch.branch.resultURL,
        notifyResultURL: branch.branch.notifyResultURL,
        notifyResultURLKo: branch.branch.notifyResultURLKo,
        contactEmail: branch.branch.contactEmail,
        notifyEmailKo: branch.branch.notifyEmailKo || false,
        contactPhone: branch.branch.contactPhone,
        processingEnv: branch.branch.processingEnv,
        onlineVersion: branch.branch.onlineVersion || DEFAULT_ONLINE_VERSION,
        branding: {
          puceV2CustomCssRef: "",
          puceLogoRef: "",
          ...lodash.cloneDeep(branch.branch.branding)
        }
      };
      util.promiseEnd(this.refreshURLs());
    }
    setTimeout(() => {
      this.puceExpanded = !!branch.branch.isNew;
      this.paylinkExpanded = !!branch.branch.isNew;
    }, 500);
  }

  get rulesDisplayName() {
    return [util.rules.required("Indique el nombre del comercio.")];
  }

  get rulesContactEmail() {
    return [
      util.rules.required("Indique un correo electrónico de contacto."),
      util.rules.email("El correo electrónico debe ser válido.")
    ];
  }

  get rulesContactPhone() {
    return [util.rules.required("Indique un número telefónico."), util.rules.phone("El teléfono debe ser válido.")];
  }

  get rulesSenderName() {
    return [util.rules.required("Indique un nombre de contacto.")];
  }

  get rulesResultEmail() {
    return [util.rules.email("El correo electrónico debe ser válido.", true)];
  }

  validateForm() {
    if (!this.activeBranch) {
      return false;
    }
    const validForm = (this.$refs.branchForm as VueForm).validate();
    const validImage = !this.activeBranch.branch.paymentLink || this.validateImage();
    return validForm && validImage;
  }

  validateImage() {
    if (!this.activeBranch) {
      return false;
    }
    this.activeBranch.invalidLogo = !this.activeBranch.draft || !this.activeBranch.draft.branding.logoFileRef;
    return !this.activeBranch.invalidLogo;
  }

  async cmdSaveBranch() {
    if (this.activeBranch && this.activeBranch.draft) {
      if (this.validateForm()) {
        this.activeSaving = true;
        try {
          const result = await domain.backend.paymentSaveBranch({
            companyID: this.activeBranch.branch.companyID,
            branchID: this.activeBranch.branch.branchID,
            draft: false,
            branchConfig: {
              ...this.activeBranch.draft
            }
          });
          const branchItem = this.activeBranch;
          const oldTitle = branchItem.title;
          this.activeBranch = null;
          this.mapBranch(branchItem, result.result);
          branchItem.saveErrCode = result.code;
          branchItem.draft = undefined;
          if (oldTitle !== branchItem.title) {
            this.assignBranches(this.branches);
          }
          this.cmdSelectBranch(branchItem);
        } catch (err) {
          util.logError("Error saving", err);
          this.snackbar.show(uiUtil.toErrorMsg(err, "No se pudo guardar la informacion"), "error");
        }
        this.activeSaving = false;
      } else {
        this.activeBranch.saveErrCode = "invalid-fields";
        setTimeout(() => {
          if (this.activeBranch) this.activeBranch.saveErrCode = "";
        }, 2000);
      }
    }
  }

  async uploadLogoSuccess(newFileRef: string) {
    if (this.activeBranch && this.activeBranch.draft) {
      this.activeBranch.draft.branding.logoFileRef = await this.removePrevious(
        newFileRef,
        this.activeBranch.draft.branding.logoFileRef
      );
      await this.refreshURLs();
    }
    this.validateImage();
  }

  async uploadPuceLogoSuccess(newFileRef: string) {
    if (this.activeBranch && this.activeBranch.draft) {
      this.activeBranch.draft.branding.puceLogoRef = await this.removePrevious(
        newFileRef,
        this.activeBranch.draft.branding.puceLogoRef
      );
      await this.refreshURLs();
    }
  }

  async uploadPuceCssSuccess(newFileRef: string) {
    if (this.activeBranch && this.activeBranch.draft) {
      this.activeBranch.draft.branding.puceV2CustomCssRef = await this.removePrevious(
        newFileRef,
        this.activeBranch.draft.branding.puceV2CustomCssRef
      );
      await this.refreshURLs();
    }
  }

  uploadLogoFailed(err: AnyErrorType) {
    this.uploadFailed(err);
    this.validateImage();
  }

  uploadFailed(err: AnyErrorType) {
    this.snackbar.show(uiUtil.toErrorMsg(err, "No se pudo subir el archivo, intentelo nuevamente"), "error");
    util.logError("Upload Failed", err);
  }

  async removePrevious(newFileRef: string, prevFileRef?: string) {
    if (newFileRef !== prevFileRef && prevFileRef) {
      try {
        const result = await domain.backend.removeStorageFileIfTemp(prevFileRef);
        if (result) {
          util.log("Removed succesfully", prevFileRef);
        }
      } catch (err) {
        util.logError("Error removing file", prevFileRef, err);
      }
    }
    return newFileRef;
  }

  cmdRemovePUCECss() {
    util.promiseEnd(this.uploadPuceCssSuccess(""));
  }

  async refreshURLs() {
    if (!this.activeBranch || !this.activeBranch.draft) {
      this.previewURLs = {
        logoURL: "",
        puceLogoURL: "",
        puceCustomCssURL: ""
      };
    } else {
      this.previewLoading = true;
      try {
        this.previewURLs = {
          logoURL: await fileStorage.resolveRefToURL(this.activeBranch.draft.branding.logoFileRef),
          puceLogoURL: await fileStorage.resolveRefToURL(this.activeBranch.draft.branding.puceLogoRef),
          puceCustomCssURL: await fileStorage.resolveRefToURL(this.activeBranch.draft.branding.puceV2CustomCssRef)
        };
      } catch (err) {
        this.snackbar.show("No se pudo generar la previsualización", "error");
      }
      this.previewLoading = false;
    }
  }

  emptyBranchItem(): BranchItem {
    return {
      branch: {
        ...this.emptyBranchBase(),
        companyID: 0,
        companyName: "",
        branchID: 0,
        name: "",
        draft: this.emptyBranchBase(),
        paymentLink: false
      },
      title: "",
      subtitle: "",
      status: "",
      logoShape: "circle",
      logoRef: "",
      invalidLogo: false,
      saveErrCode: ""
    };
  }

  emptyBranchBase(): DBBranchBase {
    return {
      enabled: true,
      displayName: "",
      contactEmail: "",
      contactPhone: "",
      senderName: "",
      resultEmail: "",
      notifyResultURLKo: "",
      notifyResultURL: "",
      notifyEmailKo: false,
      resultURL: "",
      processingEnv: "prod",
      branding: {
        primaryColor: "",
        secondaryColor: "",
        logoShape: "circle",
        logoFileRef: "",
        puceFooterType: "company_name",
        puceV2CustomCssRef: "",
        puceLogoRef: ""
      }
    };
  }
}

interface BranchItem {
  branch: DBBranchData;
  draft?: DBBranchBase;
  title: string;
  subtitle: string;
  status: string;
  logoRef: string;
  logoShape: LogoShape;
  invalidLogo: boolean;
  saveErrCode: string;
}
